<template>
    <div>
        <h1>맞춤형 건강 서비스 제공을 위한 의료 마이데이터 민감정보 활용 동의</h1>
        주식회사 솔닥(이하 “회사”라 합니다)은 회원의 의료 마이데이터를 활용하여 맞춤형 건강 콘텐츠, 건강관리 안내, 건강관리 프로그램 및 서비스 추천 등 맞춤형 건강 서비스를 제공하기 위해 아래와 같이 회원의 민감정보를 수집·이용하고자 합니다.<br>
        본 동의는 선택 동의이며, 동의하지 않더라도 솔닥 의료 마이데이터 기본 조회 서비스 이용에는 제한이 없습니다. 다만, 맞춤형 건강 서비스의 전부 또는 일부 이용이 제한될 수 있습니다.<br>
        <h3>제1조 (민감정보 활용 목적)</h3>
        1. 회사는 다음 목적을 위하여 회원의 의료 마이데이터 민감정보를 활용합니다.<br>
        가. 회원의 건강정보를 기반으로 한 맞춤형 건강 콘텐츠 제공<br>
        나. 건강검진정보, 투약이력, 진료이력 등을 기반으로 한 건강관리 안내 제공<br>
        다. 회원의 건강 상태, 진료이력, 투약이력, 검사결과 등을 고려한 건강관리 프로그램 및 서비스 추천<br>
        라. 만성질환, 건강검진, 복약관리, 예방접종 등 건강관리 필요 항목에 대한 맞춤형 안내 제공<br>
        마. 회원의 건강정보 이해를 돕기 위한 항목별 요약, 분류, 시각화 및 관리 정보 제공<br>
        2. 회사는 본 동의에 따른 민감정보를 맞춤형 건강 서비스 제공 목적 범위 내에서만 활용합니다.<br>
        3. 회사는 본 동의를 근거로 회원에게 광고성 정보를 발송하거나, 의료 마이데이터를 마케팅 또는 제휴 상품 홍보 목적으로 활용하지 않습니다.<br>
        <h3>제2조 (활용하는 민감정보 항목)</h3>
        1. 회사는 회원이 솔닥 의료 마이데이터 서비스를 통해 전송요구하고 회사가 전송받은 민감정보 중 맞춤형 건강 서비스 제공에 필요한 항목을 활용할 수 있습니다.<br>
        2. 활용 대상 민감정보 항목은 다음과 같습니다.<br>
        가. 진료이력<br>
        나. 진단내역<br>
        다. 처방내역 및 약물처방정보<br>
        라. 투약이력<br>
        마. 건강검진정보<br>
        바. 암검진정보<br>
        사. 예방접종정보<br>
        아. 진단검사, 기타검사, 영상검사 및 병리검사 결과<br>
        자. 수술 및 처치내역<br>
        차. 알레르기 및 불내성 정보<br>
        카. 부작용 정보<br>
        타. 내원정보 및 진료기록요약지<br>
        파. 기타 회원이 전송요구한 건강정보 중 맞춤형 건강 서비스 제공에 필요한 정보<br>
        3. 회사는 맞춤형 건강 서비스 제공에 필요한 최소한의 민감정보만 활용합니다.<br>
        <h3>제3조 (맞춤형 건강 서비스의 내용)</h3>
        1. 회사는 회원이 전송요구한 의료 마이데이터 중 건강검진, 투약이력, 진료이력, 진단내역, 예방접종, 알레르기 및 부작용 정보 등 맞춤형 건강 서비스 제공에 필요한 정보를 활용하여 건강관리 안내, 건강정보 콘텐츠, 건강관리 프로그램 및 서비스 추천을 제공할 수 있습니다.<br>
        2. 회사가 제공하는 맞춤형 건강 서비스는 회원의 건강정보 이해와 건강관리를 돕기 위한 참고 정보이며, 의료진의 진단, 처방, 치료 또는 의학적 판단을 대체하지 않습니다.<br>
        <h3>제4조 (민감정보의 보유 및 이용기간)</h3>
        1. 회사는 본 동의에 따라 활용하는 민감정보를 회원이 본 동의를 유지하는 기간 동안 보유·이용합니다.<br>
        2. 다음 각 호의 어느 하나에 해당하는 경우 회사는 본 동의에 따른 맞춤형 건강 서비스 제공을 중단합니다.<br>
        가. 회원이 본 동의를 철회한 경우<br>
        나. 회원이 마이데이터 연동을 해지하거나 전송요구를 철회한 경우<br>
        다. 회원이 솔닥 회원을 탈퇴한 경우<br>
        라. 회원이 민감정보 삭제 또는 파기를 요청한 경우<br>
        3. 관계 법령 또는 가이드라인에 따라 보관이 필요한 정보는 해당 법령에서 정한 기간 동안 보관할 수 있습니다.<br>
        <h3>제5조 (동의 거부 및 철회)</h3>
        1. 회원은 본 민감정보 활용 동의를 거부하거나 언제든지 철회할 수 있습니다.<br>
        2. 회원이 본 동의를 거부하거나 철회하더라도 솔닥 의료 마이데이터 기본 조회 서비스 이용에는 제한이 없습니다.<br>
        3. 다만, 맞춤형 건강 콘텐츠, 건강관리 안내, 건강관리 프로그램 및 서비스 추천 등 본 동의가 필요한 기능은 이용이 제한될 수 있습니다.
    </div>
</template>

<script>
export default {
    name: 'mydataPersonalizedService'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mydata/PersonalizedService.vue